<div class="bl-max-width--tablet-width bl-margin-x--auto" data-automation-id="generic-error-card">
  <dx-content-messaging-card
    [title]="pageContent.title || ('genericError/heading' | dictionary)"
    [description]="pageContent.description || ('genericError/subheading' | dictionary)"
    [showAddress]="pageContent.showAddressBlock"
    [showPhone]="pageContent.showPhoneBlock"
    [showEmail]="pageContent.showEmailBlock"
    [addressLabel]="pageContent.addressBlockLabel"
    [phoneLabel]="pageContent.phoneBlockLabel"
    [emailLabel]="pageContent.emailBlockLabel"
  >
    <img
      src="/assets/images/opps-error-icon.svg"
      alt="icon of yellow page with exclamation mark in the center"
      class="bl-margin-y--16 bl-margin-y-md--24"
    />
  </dx-content-messaging-card>
</div>
